// RecentProject component - Converted from components/RecentProject.vue
// Recent projects section
import React from 'react';
import leafImg from '../assets/images/resources/leaf.png';
import projectImg1 from '../assets/images/project/5.png';
import projectImg2 from '../assets/images/project/6.png';
import projectImg3 from '../assets/images/project/7.png';
import projectImg4 from '../assets/images/project/8.png';
import projectImg5 from '../assets/images/project/9.png';
import projectImg6 from '../assets/images/project/10.png';

interface Project {
  title: string;
  image: string;
}

const RecentProject: React.FC = () => {
  // Projects data - converted from Vue projects array
  const projects: Project[] = [
    {
      title: 'Plantation de blé',
      image: projectImg1,
    },
    {
      title: 'Gestion durable des sols',
      image: projectImg2,
    },
    {
      title: 'Cultures biologiques',
      image: projectImg3,
    },
    {
      title: 'Récolte des olives',
      image: projectImg4,
    },
    {
      title: 'Saison des citronniers',
      image: projectImg5,
    },
    {
      title: 'Irrigation',
      image: projectImg6,
    },
    ];

  return (
    <section className="recent-project" style={{ marginBottom: '100px' }}>
      <div className="container">
        <div className="block-title text-center">
          <p>découvrez nos projets</p>
          <h3>Nos projsqdsqets récents</h3>
          <div className="leaf">
            <img src={leafImg} alt="Decorative leaf" />
          </div>
        </div>
        <div className="row">
          {projects.map((project, index) => (
            <div key={index} className="col-xl-4 col-lg-4">
              <div className="recent_project_single" style={{ marginTop: '20px' }}>
                <div 
                  className="project_img_box wow fadeInUp" 
                  data-wow-delay={`${(index + 1) * 100}ms`}
                >
                  <img src={project.image} alt={project.title} />
                  <div className="project_content">
                    <h3 style={{fontSize: '32px'}}>{project.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentProject;
